import React from 'react'
import { MainHeading, PageHeaderIntro, FindAgent, Breadcrumb, FigureCards, Faq, NewsCard } from '../../../../components';
import { images } from "../../../../utils/customFn";
import { Container } from 'react-bootstrap';
import './small-deductible-plans.scss';

const SmallDeductiblePlans = () => {

    const HeaderData = [
        {
            image: images['two-people-reading-article.svg'],
            para: 'For small or medium-sized businesses like yours, finding the right workers’ compensation program can be hard—after all, balancing the bottom line with your interest in an involved approach is difficult. But with a small deductible workers’ compensation plan from Sentry, you can enjoy a reduced premium and access to our experienced claims team while paying a small deductible when a claim does happen. We’ll work directly with you to help find the plan that works for your company.',
        },
    ];
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
        { label: "Insurance products", link: "/what-we-offer/insurance-products" },
        { label: "Workers’ compensation", link: "/what-we-offer/insurance-products/workers-compesation" },
        { label: "Small deductible plans", link: "/what-we-offer/insurance-products/workers-compensation/small-deductible-plans" },
    ];
    const faqData = [
        {
            id: 1,
            eventKey: 1,
            header: 'What are the major differences between small deductible workers’ compensation plans and large deductible plans, and why may a small deductible plan be right for my business?',
            body: 'We help owners like you determine the right insurance policy that balances the best combination of price and protection for your business—from Call us for more information or find a local insurance agent to get started on your personalized quote.'
        },
        {
            id: 2,
            eventKey: 2,
            header: 'Are there financial or eligibility-related issues I may encounter as I’m considering a small deductible plan for my company?',
            body: 'We help owners like you determine the right insurance policy that balances the best combination of price and protection for your business—from Call us for more information or find a local insurance agent to get started on your personalized quote.'
        },
        {
            id: 3,
            eventKey: 3,
            header: 'What types of claims will my small deductible plan apply towards?',
            body: 'We help owners like you determine the right insurance policy that balances the best combination of price and protection for your business—from Call us for more information or find a local insurance agent to get started on your personalized quote.'
        }
    ]
    const featuredCard = [
        {
            id: 1,
            value: "5k+",
            unit: "Sentry associates",
            description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
        },
        {
            id: 2,
            value: "8",
            unit: "Sentry leaders",
            description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
        },
        {
            id: 3,
            value: "1992",
            unit: "First year",
            description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
        },
    ];
    const NewsCardData = [
        {
            id: 1,
            title: 'Getting your employees ready to retire',
            description:
                'We have the 401(k) and other retirement plan options and services to help you and your employees plan for retirement.',
            linkUrl: '',
            linkText: 'Read more >',
        },
        {
            id: 2,
            title: 'Secure Act 2.0',
            description: 'Running a business comes with uncertainties. Protect yourself from the unknown with business liability coverage.',
            linkUrl: '/',
            linkText: 'Read more >',
        },
        {
            id: 3,
            title: 'Sentry news',
            description:
                'Protect your profits and property from the unexpected during a construction or renovation project.',
            linkUrl: '/',
            linkText: 'Read more >',
        },

    ];
    return (
        <div className='small-deductible-plans-main'>
            <Container>
                {/* Breadcrum */}
                <Breadcrumb crumbs={breadcrumbs} />

                {/* heading  */}
                <MainHeading title="Small deductible plans" showshare={false} />

                {/* page intro */}
                <PageHeaderIntro Data={HeaderData} />

                <Faq heading="FAQs" FaqData={faqData} />

                <FigureCards data={featuredCard} heading="Significant figures" />

                {/* news card section */}
                <NewsCard Title="More reasons to choose Sentry" CardData={NewsCardData} showNavLink={false} subTitle="GUIDES" />

                <FindAgent />
            </Container>
        </div>
    )
}

export default SmallDeductiblePlans;